import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { posts } from './posts';
import SEO from '../../components/SEO';

export default function BlogIndex() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: theme.colors.bgPrimary, color: theme.colors.textPrimary }}>
      <SEO
        title="Blog — Australian Data Privacy & Cloud Storage Insights | Trubonn"
        description="Insights on Australian data privacy, cloud storage, and digital security — from the Privacy Act to choosing where your files actually live."
        path="/blog"
      />

      {/* Nav */}
      <nav style={{
        padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderBottom: `1px solid ${theme.colors.border}`, position: 'sticky', top: 0,
        background: theme.colors.bgPrimary, zIndex: 1000,
      }}>
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img src="/logo.svg" alt="Trubonn Logo" style={{ height: '70px', width: '180px' }} />
        </div>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <button onClick={() => navigate('/')} style={{ background: 'transparent', border: 'none', color: theme.colors.textSecondary, cursor: 'pointer', fontSize: '15px', padding: '8px 16px' }}
            onMouseEnter={(e) => e.currentTarget.style.color = theme.colors.brand}
            onMouseLeave={(e) => e.currentTarget.style.color = theme.colors.textSecondary}>
            Home
          </button>
          <button onClick={() => navigate('/pricing')} style={{ background: 'transparent', border: 'none', color: theme.colors.textSecondary, cursor: 'pointer', fontSize: '15px', padding: '8px 16px' }}
            onMouseEnter={(e) => e.currentTarget.style.color = theme.colors.brand}
            onMouseLeave={(e) => e.currentTarget.style.color = theme.colors.textSecondary}>
            Pricing
          </button>
        </div>
      </nav>

      {/* Content */}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '80px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <h1 style={{
            fontSize: '48px', fontWeight: 800, marginBottom: '16px',
            background: theme.gradients.brand,
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          }}>
            Blog
          </h1>
          <p style={{ color: theme.colors.textSecondary, fontSize: '18px', lineHeight: 1.6 }}>
            Insights on Australian data privacy, cloud storage, and digital security.
          </p>
        </div>

        {/* Post list */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {posts.map((post) => (
            <div
              key={post.slug}
              onClick={() => navigate(`/blog/${post.slug}`)}
              style={{
                background: theme.colors.bgSecondary,
                border: `1px solid ${theme.colors.border}`,
                borderRadius: '16px',
                padding: '32px',
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 32px rgba(157, 78, 221, 0.15)';
                e.currentTarget.style.borderColor = theme.colors.brand;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = theme.colors.border;
              }}
            >
              {/* Tags */}
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
                {post.tags.slice(0, 3).map((tag) => (
                  <span key={tag} style={{
                    background: `${theme.colors.brand}20`,
                    color: theme.colors.brand,
                    fontSize: '12px',
                    fontWeight: 600,
                    padding: '3px 10px',
                    borderRadius: '8px',
                  }}>
                    {tag}
                  </span>
                ))}
              </div>

              <h2 style={{ fontSize: '22px', fontWeight: 700, color: theme.colors.textPrimary, marginBottom: '12px', lineHeight: 1.3 }}>
                {post.title}
              </h2>

              <p style={{ color: theme.colors.textSecondary, fontSize: '15px', lineHeight: 1.7, marginBottom: '20px' }}>
                {post.excerpt}
              </p>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: '16px', color: theme.colors.textTertiary, fontSize: '13px' }}>
                  <span>📅 {post.date}</span>
                  <span>⏱️ {post.readTime}</span>
                  <span>✍️ {post.author}</span>
                </div>
                <span style={{ color: theme.colors.brand, fontSize: '14px', fontWeight: 600 }}>
                  Read more →
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer style={{ padding: '40px', textAlign: 'center', borderTop: `1px solid ${theme.colors.border}`, background: theme.colors.bgPrimary }}>
        <p style={{ color: theme.colors.textSecondary, fontSize: '14px' }}>© 2026 Trubonn Systems. All rights reserved.</p>
        <div style={{ marginTop: '16px', display: 'flex', gap: '24px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="/privacy" style={{ color: theme.colors.textSecondary, textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</a>
          <a href="/terms" style={{ color: theme.colors.textSecondary, textDecoration: 'none', fontSize: '14px' }}>Terms of Service</a>
          <a href="/contact" style={{ color: theme.colors.textSecondary, textDecoration: 'none', fontSize: '14px' }}>Contact</a>
        </div>
      </footer>
    </div>
  );
}
